import { TransactionDetailRow } from "@/components/transaction/TransactionDetailRow";
import { TransactionSection } from "@/components";
import { memo } from "react";
interface TransactionFeeSectionProps {
    gasPriceUSD: string;
    slippagePercent?: number;
}

export const TransactionFeeSection = memo(function TransactionFeeSection({
    gasPriceUSD,
    slippagePercent,
}: TransactionFeeSectionProps) {
    return (
        <TransactionSection>
            <TransactionDetailRow
                slotProps={{
                    value: { className: "text-[12px]" },
                    label: { className: "text-[12px]" },
                }}
                label="Network Fee"
                value={`$${gasPriceUSD}`}
            />
            {slippagePercent && (
                <TransactionDetailRow
                    slotProps={{
                        value: { className: "text-[12px]" },
                        label: { className: "text-[12px]" },
                    }}
                    label="Slippage"
                    value={`${slippagePercent}%`}
                />
            )}
        </TransactionSection>
    );
});

TransactionFeeSection.displayName = "TransactionFeeSection";
